export default function parseUserAgent(userAgent) {
  const value = String(userAgent || "").toLowerCase();
  if (!value) return "Onbekend apparaat";

  const isIPhone = value.includes("iphone");
  const isIPad = value.includes("ipad");
  const isAndroid = value.includes("android");

  let platform = "Onbekend platform";
  if (isIPhone) platform = "iPhone";
  else if (isIPad) platform = "iPad";
  else if (isAndroid) platform = "Android";
  else if (value.includes("windows")) platform = "Windows";
  else if (value.includes("mac os") || value.includes("macintosh")) platform = "Mac";
  else if (value.includes("linux")) platform = "Linux";

  let browser = "Onbekende browser";
  if (value.includes("edg/")) browser = "Edge";
  else if (value.includes("brave")) browser = "Brave";
  else if (value.includes("firefox/")) browser = "Firefox";
  else if (value.includes("chrome/")) browser = "Chrome";
  else if (value.includes("safari/")) browser = "Safari";

  return `${platform} ${browser}`;
}
